export default __webpack_public_path__ + "static/media/A2.1d8638db.png";